module.exports = __webpack_public_path__ + "img/kcg_kingdomswapp.c5d7771.png";